import React from 'react';
import { SearchTypeAhead } from '../Search';
import SearchBox from '../srp/SearchBox';

const GlobalSearch = () => {
    return window.location.pathname.includes('/search/') ? <SearchBox /> : <SearchTypeAhead />;
};

export default GlobalSearch;
